// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".borderRadiusRight{\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.borderRadiusLeft{\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n\n.sizeImgMicrosoft{\n    width: 4.5rem;\n\n}", ""]);
// Exports
module.exports = exports;
